/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var getPanelId = function getPanelId(panel, index, nested) {
  if (panel) {
    var _panel$props;
    return ((_panel$props = panel.props) === null || _panel$props === void 0 ? void 0 : _panel$props.id) || "cpc-side-panel-".concat(index).concat(nested ? "--is-nested" : '');
  }
  return null;
};

/**
 * Generates pagination details about a side panel by using information about its surrounding components.
 * @param {*} panel
 * @param {*} index
 * @param {*} panels
 * @param {*} activeId
 * @param {*} isNested
 */
var getPanelDetails = function getPanelDetails(panel, index, activeId) {
  var _panel$props2;
  var panels = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var isNested = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var previousIndex = index - 1;
  var nextIndex = index + 1;
  var id = getPanelId(panel, index, isNested);
  var nextId = getPanelId(panels[nextIndex], nextIndex, isNested);
  var previousId = getPanelId(panels[previousIndex], previousIndex, isNested);
  return {
    id: id,
    nextId: nextId,
    previousId: previousId,
    isActive: id === activeId,
    isNextActive: nextId === activeId,
    isPreviousActive: previousId === activeId,
    isNestedActive: panel === null || panel === void 0 || (_panel$props2 = panel.props) === null || _panel$props2 === void 0 || (_panel$props2 = _panel$props2.nestedPanels) === null || _panel$props2 === void 0 ? void 0 : _panel$props2.find(function (nestedPanel) {
      return getPanelId(nestedPanel, id, true) === activeId;
    })
  };
};

export { getPanelDetails, getPanelId };
